import { render } from "./VtoPageMain.vue?vue&type=template&id=082c3022"
import script from "./VtoPageMain.vue?vue&type=script&lang=js"
export * from "./VtoPageMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__